/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Type_Delivery_PaidInputs */

const vi_notif_type_delivery_paid = /** @type {(inputs: Notif_Type_Delivery_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn giao đã nhận tiền`)
};

/**

* @param {Notif_Type_Delivery_PaidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_type_delivery_paid = /** @type {((inputs?: Notif_Type_Delivery_PaidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Type_Delivery_PaidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_type_delivery_paid(inputs)
});